export default __webpack_public_path__ + "static/media/ad-super.9a27b33d.jpeg";